import { ActionTypes } from "../action-type";

const initialState = {
    skin_tone:null,
    hair_color:null,
    dress_color:null,
    gender:null,
    profile_exist:null
}

export const avatarReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.AVATAR:
            return {...state,skin_tone:action.payload.skin_tone,
                hair_color:action.payload.hair_color,
                dress_color:action.payload.dress_color,
                gender:action.payload.gender,
                profile_exist:action.payload.profile_exist,
            }
        case ActionTypes.CHANGE_GENDER:
            return{...state,gender:action.payload.gender}
        default:
            return state;
    }
}


